import React from 'react'
import PropTypes from 'prop-types'
import Menu from '@mui/material/Menu'
import ScrollDialogComponent from './ScrollDialogComponent'
import {MenuPaperpropsValue} from '../SideBar/SideBarStyle'
import {
  StyledMenuItem,
  StyledBox,
  StyledAnchorMenuItem,
  StyledDivider,
  StyledTypography
} from './AppInfoComponentStyles'

const openInNewTab = (url) => {
  globalThis.open(url, '_blank', 'noopener,noreferrer')
}
const privacyStatementUrl = 'https://www2.deloitte.com/us/en/footerlinks1/deloitte-commercial-asset-privacy-notice.html'
const AppInfoComponent = ({openAppInfo, anchorAppInfoEl, setAnchorAppInfoEl}) => {
  const [heading, setHeading] = React.useState('')
  const [dialog, setDialog] = React.useState(false)

  const handleChange = (event, toggleDialog) => {
    if (event) {
      const targetHeading = event.target.innerText.toLowerCase()
      switch (targetHeading) {
        case 'terms of use':
          setHeading('Terms of Use')
          break
        case 'legal notice':
          setHeading('Legal Notice')
          break
        default:
          setHeading('')
      }
    }
    event ? setDialog(event) : setDialog(toggleDialog)
  }

  const handleClose = () => {
    setAnchorAppInfoEl(null)
  }

  return (
    <StyledBox key='info_box'>
      <Menu
        data-testid='app-info-menu'
        open={openAppInfo}
        anchorEl={anchorAppInfoEl}
        id='info-menu'
        onClose={handleClose}
        transformOrigin={{horizontal: 'left', vertical: 'bottom'}}
        anchorOrigin={{horizontal: 'left', vertical: 'top'}}
        PaperProps={MenuPaperpropsValue}
      >
        <StyledTypography variant='h6' id='contact-info'>
          Contact Info
        </StyledTypography>
        <StyledAnchorMenuItem
          variant='subtitle2'
          component='a'
          href='https://deloittesupportportal.service-now.com/csm'
          target='_blank'
          rel='noopener noreferrer'
        >
          Customer Support
        </StyledAnchorMenuItem>
        <StyledDivider style={{marginTop: '0px', marginBottom: '0px'}} />
        <StyledMenuItem onClick={() => openInNewTab(privacyStatementUrl)} target='_href'>
          Privacy Statement
        </StyledMenuItem>
        <StyledMenuItem onClick={handleChange} target='_blank'>
          Terms of Use
        </StyledMenuItem>
        <StyledMenuItem onClick={handleChange} target='_blank'>
          Legal Notice
        </StyledMenuItem>
        <StyledMenuItem
          onClick={() => openInNewTab('https://cookienotice.deloitte.com')}
          target='_href'
          rel='noopener noreferrer'
        >
          Cookies
        </StyledMenuItem>
        <StyledMenuItem onClick={() => globalThis.OneTrust?.ToggleInfoDisplay()}>Cookie Settings</StyledMenuItem>
      </Menu>

      {dialog && <ScrollDialogComponent setOpen header={heading} onChange={handleChange} />}
    </StyledBox>
  )
}

AppInfoComponent.propTypes = {
  openAppInfo: PropTypes.bool,
  anchorAppInfoEl: PropTypes.object,
  setAnchorAppInfoEl: PropTypes.func,
  anchorEl: PropTypes.shape({
    current: PropTypes.object
  })
}
export default AppInfoComponent
